import { apiRequest } from './client'

export interface MfaFactor {
  id: string
  factorType: string
  friendlyName: string | null
  createdAt: string
}

export interface MfaStatusResponse {
  enrolled: boolean
  factors: MfaFactor[]
}

export type MfaAuditAction =
  | 'mfa.enrolled'
  | 'mfa.unenrolled'
  | 'mfa.challenge_success'
  | 'mfa.challenge_failed'
  | 'mfa.recovery_codes_regenerated'
  | 'mfa.recovery_code_used'

export const mfaApi = {
  async getStatus(): Promise<MfaStatusResponse> {
    return apiRequest<MfaStatusResponse>('/auth/mfa/status')
  },

  async recordAudit(action: MfaAuditAction, factorId?: string): Promise<void> {
    await apiRequest('/auth/mfa/audit', {
      method: 'POST',
      body: { action, factorId },
    })
  },
}
